import type { Bono, ItemValor } from '../types/content';
export const bonos: Bono[] = [{
  numero: 1,
  icono: "📱",
  nombre: '100 Respuestas Profesionales para Enviar a tus Clientas',
  descripcion: 'Respuestas listas para adaptar en tu atención diaria. Ahorras tiempo, evitas malentendidos, comunicas como profesional.',
  valor: '$7 USD'
}, {
  numero: 2,
  icono: '📸',
  nombre: '50 Ideas de Fotos Premium para Mostrar tus Trabajos de Uñas',
  descripcion: 'Poses, ángulos y encuadres para mostrar tu trabajo con estilo profesional, prolijo y atractivo en redes.',
  valor: '$7 USD'
}, {
  numero: 3,
  icono: '💅',
  nombre: 'Manual Express para Uñas Mordidas y Difíciles',
  descripcion: 'Qué observar, evitar y adaptar cuando la clienta llega con uñas difíciles. Sin improvisar. Con seguridad.',
  valor: '$7 USD'
}, {
  numero: 4,
  icono: '✨',
  nombre: 'Protocolo de Visagismo',
  descripcion: "Elegí la forma ideal de uña para cada mano. Estilizá los dedos de tus clientas y demostrá autoridad experta en cada servicio.",
  valor: '$7 USD'
}, {
  numero: 5,
  icono: '🧴',
  nombre: 'Mesa de Trabajo Lista en 5 Minutos',
  descripcion: 'Checklist de Mesa Pro: el paso a paso para organizar tu espacio y materiales. Empezá cada servicio con total seguridad, orden y prolijidad.',
  valor: '$7 USD'
}];
export const itemsValor: ItemValor[] = [{
  nombre: 'Tomo 1 — El Cronómetro de Oro',
  precio: '$17 USD'
}, {
  nombre: 'Tomo 2 — El Menú de Diseños “Cash”',
  precio: '$17 USD'
}, {
  nombre: 'Tomo 3 — El Escudo Anti-Reclamos',
  precio: '$17 USD'
}, {
  nombre: 'Tomo 4 — La Máquina de Ganancia Real',
  precio: '$17 USD'
}, {
  nombre: 'Tomo 5 — Imán de Clientas Premium',
  precio: '$17 USD'
}, {
  nombre: 'Tomo 6 — El Botiquín de Crisis',
  precio: '$17 USD'
}, {
  nombre: 'Bono 1 — 100 Respuestas Profesionales',
  precio: '$7 USD'
}, {
  nombre: 'Bono 2 — 50 Ideas de Fotos Premium',
  precio: '$7 USD'
}, {
  nombre: 'Bono 3 — Manual de Uñas Difíciles',
  precio: '$7 USD'
}, {
  nombre: 'Bono 4 — Protocolo de Visagismo',
  precio: '$7 USD'
}, {
  nombre: 'Bono 5 — Mesa de Trabajo Lista',
  precio: '$7 USD'
}];
export const valorTotal = '$137 USD';